module.exports = __webpack_public_path__ + "img/logo_sudcontractors.06c7e92a.png";